var map = {
	"./anxiang/top-bgimg.png": "xdyh",
	"./default/top-bgimg.png": "IbSd",
	"./huarong/top-bgimg.png": "Wic3",
	"./master/top-bgimg.png": "mD5x",
	"./shaodong/top-bgimg.png": "FYi9",
	"./taoyuan/top-bgimg.png": "9jFV",
	"./yueyang/top-bgimg.png": "j3ca",
	"./zhuzhou/top-bgimg.png": "Ux1M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IpWa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/top\-bgimg\.png$
// module id = IpWa
// module chunks = 1